import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Loading from '../components/Loading/LoadingComponent';


const PrivateRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <Loading />; 
  }
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute;
